import React, { useState, useEffect } from 'react';
import Sidebar from '../common/Sidebar';
import Header from '../common/Header';
import { useLanguage } from '../../hooks/useLanguage';
import './MainLayout.css';

const MOBILE_SHELL_MQ = '(max-width: 1024px)';

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobileShell, setIsMobileShell] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_SHELL_MQ).matches : false
  );
  const { isRTL } = useLanguage();

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_SHELL_MQ);
    const onChange = (e) => {
      setIsMobileShell(e.matches);
      if (!e.matches) setSidebarOpen(false);
    };
    // Safari < 14
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    setIsMobileShell(mq.matches);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  useEffect(() => {
    if (!(sidebarOpen && isMobileShell)) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [sidebarOpen, isMobileShell]);

  const toggleSidebar = () => setSidebarOpen((open) => !open);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div
      className={`layout ${isRTL ? 'rtl' : ''} ${
        sidebarOpen && isMobileShell ? 'sidebar-open-mobile' : ''
      }`}
    >
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <Header onMenuClick={toggleSidebar} />
      <main className="main-content">{children}</main>
    </div>
  );
};

export default MainLayout;
